<div id="page_faqs">
    <div id="box-pages" class="block_pages">
        <div class="head">
            <fa-icon [icon]="FAIcon" class="pageicon"></fa-icon>
            <h1 class="title">FAQ</h1>
            <br/>
            <p class="total" *ngIf="model_faqs.length > 0">{{ model_faqs.length }} registros</p>
        </div>

        <div class="window" style="opacity: 1;">
            <div *ngIf="model_faqs.length <= 0" class="empty"><br/><br/><br/>
                <p style="text-align: center;color: #ccc;">Nenhum registro encontrado</p>
            </div>
            <ul *ngIf="model_faqs" style="padding-bottom: 9px;opacity: 1;" >
                <li id="phome-liplanbox{{ reg.id }}" *ngFor="let reg of model_faqs" class="content box alivebg{{ reg.alive }}"  style="opacity: 1;padding-bottom: 9px;">
                    <div id="planbox{{ reg.id }}" class="alertbox" style="position: relative;">
                        
                        <fa-icon [icon]="FAIcon" class="boxicon"></fa-icon>

                        <h4>{{ reg.question }}</h4>
                        <p style="line-height: 25px;padding: 18px 18px 27px;">{{ reg.answer  }}</p>
                        
                        <a *ngIf="reg.alive == 1 && lhaylie.player_permission(true, 0) == 1" class="btn_check fix" 
                            style="float: right;background: #0095f6;padding: 3px;margin-right: 9px;"
                            (click)="goHaylie('edit', reg.id.toString())">
                            <fa-icon [icon]="frmFAIcon" class="pageicon"
                            style="font-size: 18px; display: block; margin: 9px;  
                                    text-align: left; color: #fff;"></fa-icon>
                        </a>
                        
                    </div>
                </li>
            </ul>

            <div id="frmfaq" *ngIf="page_frm" class="content box"
                style="opacity: 1; position: absolute;top: 90px;box-shadow: 1px 2px 2px #000;">
                
                <fa-icon [icon]="frmFAIcon" class="pageicon"
                        style="font-size: 18px; display: block; margin: 12px;  
                                text-align: left; color: #111;"></fa-icon>
                <h1 class="srt" style="    top: 18px;left: 52.77px;font-size: 12px;">FAQ | DETALHES</h1>
                <p class="sub" id="msgbox"></p>
                <br/>
                <div class="frm">
                    <br/>
                    <label>Pergunta</label><br>
                    <textarea #faq_question class="inputtxt" placeholder="> Pergunta" aria-multiline="true"
                        >{{ model_frm_question }}</textarea>
                    
                    <br/>
                    <label>Resposta</label><br>
                    <textarea #faq_answer class="inputtxt" placeholder="> Resposta" aria-multiline="true"
                        >{{ model_frm_answer }}</textarea>
                    
                    <br/>
                    <button class="btn-splatter" (click)="goHaylie('frm', '0')"
                        style="top: 63px; font-size: 9px; letter-spacing: 3px;">
                        SALVAR</button>
                    <a class="btnReturn" (click)="switchFrm('off')">
                        VOLTAR</a>

                    <a class="btnrectransp" *ngIf="player_permission == 1 && model_frm_id > 0" 
                        (click)="goHaylie('delete', '')" 
                        style="color: #0095f6; border: 1px solid;top: 90px;position: relative;">
                        EXCLUIR</a>
                </div>
            </div>
            
        </div> 

        <a id="btn_frm" class="fixed_action" 
            *ngIf="player_permission == 1"
            (click)="switchFrm('on')">
            <fa-icon [icon]="FAIconPlus" class="ico"></fa-icon>
        </a>
    </div>

</div>